
<!-- OrderDetails.svelte -->

<script>
    import { createEventDispatcher, onMount, onDestroy } from 'svelte';
    import { App } from '@capacitor/app';
    import { Capacitor } from '@capacitor/core';
    import backarrow from './assets/backarrow.png';

    import { Plugins } from '@capacitor/core';



    export let orderId;
    const dispatch = createEventDispatcher();

    let headerRef;
    let orderDetails = null;
    let loading = true;
    let error = null;
    let selectedImage = null;

    let backButtonListener;

    onMount(async () => {
        try {
            const accessToken = localStorage.getItem('accessToken');
            const response = await fetch('https://groupfruits.online/shop/api/OrderSummaryView/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `JWT ${accessToken}`
                },
                body: JSON.stringify({ order_id: orderId })
            });

            if (!response.ok) {
                throw new Error('Failed to fetch order details');
            }

            orderDetails = await response.json();
            loading = false;
            window.scrollTo(0, 0);
        } catch (err) {
            error = err.message;
            loading = false;
        }

		if (Capacitor.isNativePlatform()) {
			App.addListener('backButton', handleAndroidBack);
		}
    });


onDestroy(() => {
    if (Capacitor.isNativePlatform()) {
        App.removeListener('backButton', handleAndroidBack);
    }
});


function handleAndroidBack() {
    dispatch('close');
}


function goBack() {
    dispatch('close');
}

    function getStatusColor(status) {
        switch (status.toLowerCase()) {
            case 'confirmed': return '#E8F5E9';
            case 'failed': return '#FFEBEE';
            case 'packing': return '#FFF3E0';
            case 'packed': return '#E3F2FD';
            case 'vehicle started': return '#F3E5F5';
            case 'pickup now': return '#E0F7FA';
            case 'cancelled': return '#FAFAFA';
            default: return '#F7FBFF';
        }
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    }

    function formatDateTime(dateString) {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'pm' : 'am';

        return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
    }

    function formatPickupDate(dateString, timeString) {
        const pickupDate = new Date(dateString);
        const day = pickupDate.getDate().toString().padStart(2, '0');
        const month = (pickupDate.getMonth() + 1).toString().padStart(2, '0');
        const year = pickupDate.getFullYear();

        const timeParts = timeString.split(':');
        let hours = parseInt(timeParts[0], 10);
        const minutes = timeParts[1];
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const formattedTime = `${hours}:${minutes} ${ampm}`;

        return `${day}-${month}-${year} (${formattedTime})`;
    }

    function openGoogleMaps() {
        if (orderDetails.order.delivery_point_details.gmaps_url) {
            window.open(orderDetails.order.delivery_point_details.gmaps_url, '_blank');
        }
    }

    function showEnlargedImage(image) {
        selectedImage = image;
    }

    function closeEnlargedImage() {
        selectedImage = null;
    }
	
</script>

<div class="order-details-modal">
    <div class="header" bind:this={headerRef}>
        <span class="back-button" on:click={goBack}>
            <img src={backarrow} alt="Back" />
        </span>
        <h1 style="margin-left: 16px;">Order Details</h1> 
    </div>

    <div class="order-details-content">
        {#if loading}
            <div class="loader-container">
                <div class="loader">
                    <svg class="circular" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
                    </svg>
                </div>
                <p class="loading-text">Fetching order details...</p>
            </div>
        {:else if error}
            <p class="error">{error}</p>
        {:else if orderDetails}
		
		
            <div class="delivery-status" style="background-color: {getStatusColor(orderDetails.order.merged_status)}">
                <h2>{orderDetails.order.merged_status}</h2>
                <p class="pickup-date">Pickup Date: {formatPickupDate(orderDetails.order.merged_pickup_date, orderDetails.order.delivery_time)}</p>

                {#if orderDetails.order.delivery_details && orderDetails.order.delivery_details.pickup_code}
                    <div class="pickup-code-card">
                        <span class="pickup-code-label">Pickup Code</span>
                        <strong class="pickup-code-value">{orderDetails.order.delivery_details.pickup_code}</strong>
                    </div>
                {/if}
                <div class="separator"></div>
                <div class="pickup-point">
                    <span class="icon">&#128205;</span>
                    <span class="label">Pickup Point</span>
                </div>
                <p class="pointname">{orderDetails.order.delivery_point_details.area_label}</p>
                <p class="pointname">{orderDetails.order.delivery_point_details.name}</p>
                <p class="address">{orderDetails.order.delivery_point_details.address}</p>
            </div>

            <div class="order-items">
                <h3>Order ({orderDetails.order.items_count} Items)</h3>
                {#each orderDetails.order.order_items as item, index}
                    <div class="item">
                        <div class="item-details">
                            <span class="item-name">{item.product_title}</span>
                            <span class="item-quantity">{item.order_time_unit} {item.order_time_measurement_unit} | ₹{item.price}</span>
                        </div>
                        <div class="item-price">
                            <div class="quantity">x {item.quantity}</div>
                            <div class="price">₹{item.subtotal}</div>
                        </div>
                    </div>
                    {#if index < orderDetails.order.order_items.length - 1}
                        <div class="item-separator"></div>
                    {/if}
                {/each}
                <div class="total">
                    <span>Total Amount</span>
                    <span class="price">₹{orderDetails.order.total_price}</span>
                </div>
            </div>

            <div class="order-summary">
                <h3>Order Summary</h3>
                <div class="summary-item">
                    <span>Order Date</span>
                    <span>{formatDateTime(orderDetails.order.created_at)}</span>
                </div>
                
                {#if orderDetails.order.transaction_details}
                    <div class="summary-item">
                        <span>Payment Status</span>
                        <span>{orderDetails.order.transaction_details.status}, UPI (UTR: {orderDetails.order.transaction_details.utr_number})</span>
                    </div>
                {/if}
                
                {#if orderDetails.order.payment_type === 'cash'}
                    <div class="summary-item">
                        <span>Payment</span>
                        <span>₹{orderDetails.order.total_price} (Cash)</span>
                    </div>
                {/if}           
            </div>

            <div class="pickup-location">
                <h3>Pickup Location</h3>
                <div class="pickup-address">
                    <h5>{orderDetails.order.delivery_point_details.name}</h5>
                    <p>{orderDetails.order.delivery_point_details.address}</p>
                </div>
                <div class="map-container" on:click={openGoogleMaps}>
                    <img src={orderDetails.order.delivery_point_details.image} alt="Pickup Location Map" class="map-image"/>
                    <div class="map-overlay">
                        <span class="map-text">Open in Google Maps</span>
                    </div>
                </div>
                <div class="location-images">
                    {#each orderDetails.order.delivery_point_details.images as image}
                        <img 
                            src={image.image} 
                            alt={image.alt_text || "Pickup Location"} 
                            class="location-image"
                            on:click={() => showEnlargedImage(image)}
                        />
                    {/each}
                </div>
                <div class="pickup-contact">
                    <h4>Pickup point contact</h4>
                    {#if orderDetails.order.delivery_point_details.phone_number && orderDetails.order.delivery_point_details.alternate_phone_number}
                        <p>{orderDetails.order.delivery_point_details.phone_number}, {orderDetails.order.delivery_point_details.alternate_phone_number}</p>
                    {:else if orderDetails.order.delivery_point_details.phone_number}
                        <p>{orderDetails.order.delivery_point_details.phone_number}</p>
                    {:else}
                        <p>NA</p>
                    {/if}

                    <h4>Shop timings</h4>
                    <p>{orderDetails.order.delivery_point_details.timings}</p>

                </div>

				
            </div>
        {/if}
    </div>
</div>

{#if selectedImage}
    <div class="enlarged-image-overlay" on:click={closeEnlargedImage}>
        <img src={selectedImage.image} alt={selectedImage.alt_text || "Enlarged Image"} class="enlarged-image"/>
    </div>
{/if}

<style>
    * {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }



.order-details-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

    .header {
        position: sticky; 
        top: 0;
        left: 0;
        right: 0;
        background-color: white;		
        padding: 16px; 
        z-index: 10;
        box-sizing: border-box;
        border-bottom: 0.1px solid #e5dada; 
        box-shadow: none; 
        display: flex; 
        align-items: center; 
    }

    .back-button {
        width: 24px; 
        height: 24px; 
        cursor: pointer;
    }

    .back-button img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }


    h1 {
        font-size: 19px; 
        margin: 0; 
    }

.order-details-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  padding-bottom: 16px;
}


    .delivery-status {
        padding: 20px;
        border-radius: 12px;
        margin-bottom: 24px;
        text-align: center;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        transition: background-color 0.3s ease;
    }


.delivery-status h2 {
    font-size: 28px;
    margin-bottom: 12px;
    font-weight: 700;
    margin-top: 0;
    color: #333;
    text-transform: capitalize;
}

.pickup-date {
    font-size: 16px;
    color: #555;
    margin-bottom: 12px;
}

.delivery-message {
    color: #4CAF50;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 25px;
    margin-top: 12px;
}

    .pickup-code {
        background-color: #4CAF50;
        color: white;
        padding: 18px 16px;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 26px;
    }

    .pickup-code span {
        font-size: 12px;
    }

    .pickup-code strong {
        font-size: 28px;
        letter-spacing: 2px;
    }

.separator {
    border-top: 1px dashed #ccc;
    margin: 20px 0;
}

.pickup-point {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.pickup-point .icon {
    margin-right: 8px;
    font-size: 20px;
}

.pickup-point .label {
    font-weight: 600;
    color: #333;
}

.address {
    margin-top: 3px;
    font-size: 14px;
    color: #555;
    padding: 0 10px;
    text-align: left;
}

.pointname {
    margin-top: 8px;
    font-size: 14px;
    color: #555;
    padding: 0 10px;
    text-align: left;
	margin-bottom: 0px;
}

    .order-items, .order-summary {
        background-color: #fff;
        padding: 16px;
        border-radius: 8px;
        margin-bottom: 16px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    h3 {
        font-size: 21px;
        font-weight: 600;
        margin-bottom: 25px;
    }

    .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
    }

    .item-details {
        display: flex;
        flex-direction: column;
		padding-right: 25px;
    }

    .item-name {
        font-weight: 600;
        font-size: 16px;
    }

    .item-quantity {
        color: #252C2C;
        font-size: 13px;
        margin-top: 4px;
    }

    .item-price {
        text-align: right;
    }

    .quantity {
        font-size: 14px;
        color: #666;
        font-weight: 600;
    }

    .price {
        color: #E91E63;
        font-weight: 600;
        font-size: 14px;
        margin-top: 2px;
    }

    .item-separator {
        border-top: 1px solid #eee;
        margin: 16px 0;
    }

    .total {
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
        font-weight: 600;
        border-top: 1px solid #eee;
        padding-top: 12px;
    }

    .summary-item {
        margin-bottom: 16px;
        font-size: 14px;
    }

    .summary-item span:first-child {
        color: #666;
        display: block;
        margin-bottom: 4px;
    }

    .summary-item span:last-child, .summary-item a {
        display: block;
        font-weight: 600;
    }

    .location-link {
        color: #2196F3;
        text-decoration: none;
    }

    .cancel-order {
        background-color: #FF4081;
        color: white;
        border: none;
        padding: 12px;
        width: 100%;
        border-radius: 4px;
        margin-top: 24px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
    }

    .cancellation-note {
        text-align: center;
        color: #666;
        font-size: 12px;
        margin-top: 8px;
    }

    .error {
        color: red;
    }


    .pickup-code-card {
        background: linear-gradient(90deg, #026402, #9e9f04);
        color: white;
        padding: 17px 16px 14px;
        border-radius: 12px;
        position: relative;
        text-align: center;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
        margin-bottom: 31px;
		margin-top:35px;
    }

    .pickup-code-label {
        position: absolute;
        top: -10px;
        left: 16px;
        background-color: #000;
        padding: 4px 12px;
        border-radius: 5px;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .pickup-code-value {
        font-size: 35px;
        letter-spacing: 4px;
        font-weight: 700;
        display: block;
    }



    .pickup-location {
        background-color: #fff;
        padding: 16px;
        border-radius: 8px;
        margin-bottom: 16px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }


    .pickup-address {
        margin-bottom: 16px;
    }

    .pickup-address h4 {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 8px;
        color: #333;
    }

    .pickup-address h5 {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 2px;
        margin-top: 2px;
        color: #333;
    }

    .pickup-address p {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
    }


    .map-container {
        position: relative;
        margin-bottom: 16px;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
    }

    .map-image {
        width: 100%;
        height: auto;
        display: block;
    }

    .map-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    .map-container:hover .map-overlay {
        opacity: 1;
    }

    .map-text {
        color: white;
        font-weight: bold;
        text-shadow: 1px 1px 2px rgba(0,0,0,0.8);
    }

    .location-images {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .location-image {
        width: calc(33.333% - 8px);
        height: 100px;
        object-fit: cover;
        border-radius: 4px;
        cursor: pointer;
        transition: transform 0.2s ease;
    }

    .location-image:hover {
        transform: scale(1.05);
    }

    .enlarged-image-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.9);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }

    .enlarged-image {
        max-width: 90%;
        max-height: 90%;
        object-fit: contain;
    }


    .pickup-contact {
        border-top: 1px solid #eee;
        padding-top: 16px;
    }

    .pickup-contact h4 {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 8px;
        color: #333;
    }

    .pickup-contact p {
        font-size: 14px;
        color: #666;
		margin-top: 2px;
    }

    .loader-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 300px; /* Adjust height as needed */
    }

    .loader {
        position: relative;
        margin: 0 auto;
        width: 100px;
    }

    .loader:before {
        content: '';
        display: block;
        padding-top: 100%;
    }

    .circular {
        animation: rotate 2s linear infinite;
        height: 100%;
        transform-origin: center center;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }

    .path {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
        animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
        stroke-linecap: round;
    }

    .loading-text {
        margin-top: 20px;
        font-size: 16px;
        color: #555;
        animation: pulse 1.5s ease-in-out infinite;
    }

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -35px;
        }
        100% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -124px;
        }
    }

    @keyframes color {
        100%,
        0% {
            stroke: #4CAF50;
        }
        40% {
            stroke: #2196F3;
        }
        66% {
            stroke: #FF9800;
        }
        80%,
        90% {
            stroke: #F44336;
        }
    }

    @keyframes pulse {
        0% {
            opacity: 0.6;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0.6;
        }
    }

</style>